import React, { forwardRef } from 'react';
import { Box } from '@fiverr-private/theme';
import { LinkCardProps } from '../types';
import { border } from '../shared';

const LinkCard = forwardRef<HTMLElement, LinkCardProps>(
  ({ children, href, borderRadius = 'sm', color = { default: 'linkPrimary' }, ...restProps }: LinkCardProps, ref) => (
    <Box
      as="a"
      ref={ref}
      href={href}
      boxShadow={{ hover: 'z2' }}
      borderRadius={borderRadius}
      decoration="none"
      color={color}
      {...border}
      {...restProps}
    >
      {children}
    </Box>
  )
);

LinkCard.displayName = 'LinkCard';

export default LinkCard;
